/* Live catalog, verified against the store on 2026-08-06.
   25 sellable variants across five focused products: one per furniture type,
   plus the ready-made sectional set. Nothing is estimated.
   This is only a FALLBACK — the theme reads live metafields at runtime.
   Sold-out sizes are not listed here at all: offering something we cannot ship
   wastes the one decision the customer came to make.

   2026-08-06: the sectional set was listed as 60-74 and 75-92 with a 45 inch
   chaise. Those models do not exist. The real sets are 58-67 and 68-81, and the
   chaise board covers a 38 to 45 inch section rather than one fixed length. */
let CATALOG = [
  {type:"recliner", depth:19.7, min:20, max:23, price:34.88, variantId:"47161704710317", handle:"recliner-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Recliner.jpg?width=320", stock:true},
  {type:"recliner", depth:19.7, min:30, max:32, price:37.88, variantId:"47161704743085", handle:"recliner-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Recliner.jpg?width=320", stock:true},
  {type:"loveseat", depth:19.7, min:38, max:45, price:40.88, variantId:"47161705496749", handle:"loveseat-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Loveseat.jpg?width=320", stock:true},
  {type:"loveseat", depth:23, min:38, max:45, price:50.88, variantId:"47161705529517", handle:"loveseat-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Loveseat.jpg?width=320", stock:true},
  {type:"loveseat", depth:25, min:38, max:45, price:55.88, variantId:"47161705562285", handle:"loveseat-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Loveseat.jpg?width=320", stock:true},
  {type:"loveseat", depth:19.7, min:48, max:54.5, price:42.88, variantId:"47161705595053", handle:"loveseat-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Loveseat.jpg?width=320", stock:true},
  {type:"loveseat", depth:23, min:48, max:54.5, price:51.88, variantId:"47161705627821", handle:"loveseat-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Loveseat.jpg?width=320", stock:true},
  {type:"loveseat", depth:25, min:48, max:54.5, price:53.88, variantId:"47161705660589", handle:"loveseat-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Loveseat.jpg?width=320", stock:true},
  {type:"sofa-med", depth:19.7, min:58, max:67, price:45.88, variantId:"47161706512557", handle:"sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Sofa.jpg?width=320", stock:true},
  {type:"sofa-med", depth:23, min:58, max:67, price:57.88, variantId:"47161706545325", handle:"sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Sofa.jpg?width=320", stock:true},
  {type:"sofa-med", depth:25, min:58, max:67, price:66.88, variantId:"47161706578093", handle:"sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Sofa.jpg?width=320", stock:true},
  {type:"sofa-med", depth:27, min:58, max:67, price:73.88, variantId:"47161706610861", handle:"sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/Sofa.jpg?width=320", stock:true},
  {type:"sofa-long", depth:19.7, min:68, max:81, price:50.88, variantId:"47161707004077", handle:"long-sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/81tsYL8sPwL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sofa-long", depth:23, min:68, max:81, price:65.88, variantId:"47161707036845", handle:"long-sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/81tsYL8sPwL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sofa-long", depth:25, min:68, max:81, price:75.88, variantId:"47161707069613", handle:"long-sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/81tsYL8sPwL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sofa-long", depth:27, min:68, max:81, price:82.88, variantId:"47161707102381", handle:"long-sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/81tsYL8sPwL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sofa-long", depth:30, min:68, max:81, price:86.88, variantId:"47161707135149", handle:"long-sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/81tsYL8sPwL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sofa-long", depth:25, min:82, max:96, price:90.88, variantId:"47161707200685", handle:"long-sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/81tsYL8sPwL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sofa-long", depth:27, min:82, max:96, price:95.88, variantId:"47161707233453", handle:"long-sofa-cushion-support", img:"https://mybenshome.com/cdn/shop/files/81tsYL8sPwL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sectional", depth:19.7, min:58, max:67, chaiseMin:38, chaiseMax:45, price:63.88, variantId:"47156197425325", handle:"sectional-cushion-support-set", img:"https://mybenshome.com/cdn/shop/files/718X6bm-LiL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sectional", depth:23, min:58, max:67, chaiseMin:38, chaiseMax:45, price:66.88, variantId:"47156197458093", handle:"sectional-cushion-support-set", img:"https://mybenshome.com/cdn/shop/files/718X6bm-LiL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sectional", depth:25, min:58, max:67, chaiseMin:38, chaiseMax:45, price:74.88, variantId:"47156197490861", handle:"sectional-cushion-support-set", img:"https://mybenshome.com/cdn/shop/files/718X6bm-LiL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sectional", depth:19.7, min:68, max:81, chaiseMin:38, chaiseMax:45, price:67.88, variantId:"47156197523629", handle:"sectional-cushion-support-set", img:"https://mybenshome.com/cdn/shop/files/718X6bm-LiL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sectional", depth:23, min:68, max:81, chaiseMin:38, chaiseMax:45, price:76.88, variantId:"47156197556397", handle:"sectional-cushion-support-set", img:"https://mybenshome.com/cdn/shop/files/718X6bm-LiL._AC_SL1500.jpg?width=320", stock:true},
  {type:"sectional", depth:25, min:68, max:81, chaiseMin:38, chaiseMax:45, price:79.88, variantId:"47156197589165", handle:"sectional-cushion-support-set", img:"https://mybenshome.com/cdn/shop/files/718X6bm-LiL._AC_SL1500.jpg?width=320", stock:true}
];

const LABEL = {
  'recliner':'Recliner',
  'loveseat':'Loveseat',
  'sofa-med':'Sofa',
  'sofa-long':'Long Sofa',
  'sectional':'Sectional'
};

/* ---------- which sizes each tile is allowed to offer ----------
   A customer with a 70 inch sofa does not know whether he is a Sofa or a Long
   Sofa. He knows he has a sofa, and if the Sofa tile only offers 58 to 67 he
   concludes we do not make his size and leaves.

   So the Sofa tile also carries the narrowest Long Sofa band, 68 to 81 today.
   Same variants, same stock, shown in two places.

   NEVER solve this by copying the rows. The stock behind them is one physical
   pile in an outside warehouse, and a duplicate row means we count it twice,
   sell it twice, and cancel the second order after we have taken the money.
   The band is derived from the catalog rather than typed in, so renaming or
   re-pricing a Long Sofa size keeps this in step with no second edit. */
const BORROWS_FROM = { 'sofa-med': 'sofa-long' };

function borrowedRows(type){
  const donor = BORROWS_FROM[type];
  if(!donor) return [];
  const rows = CATALOG.filter(p => p.type === donor);
  if(!rows.length) return [];
  const firstMin = Math.min(...rows.map(p => p.min));
  return rows.filter(p => p.min === firstMin);
}

/* Every place that asks what a furniture type may be offered goes through
   here, so the tiles, the depth chips and the matcher can never disagree
   about what exists. */
function poolFor(type){
  if(type === 'sectional') return CATALOG.filter(p => p.type === 'sectional');
  return CATALOG.filter(p => p.type === type).concat(borrowedRows(type));
}
window.bhPoolFor = poolFor;

/* Tunable rules.
   DEPTH_TOL  how far the board may exceed the measured depth, in inches.
   STEP_CAP   how far below a size's minimum width we will still recommend it,
              on the basis that the panel gaps can be closed up.
   CHAISE_TOL how far outside a set's chaise range the measured chaise may fall
              before we stop offering the set and build a custom pair.
   SECOND_OFF the discount on the cheaper of two boards. THIS NUMBER IS A
              PROMISE. It has to match the automatic discount in Shopify called
              "Second board, 10% off", because a button that quotes a price the
              checkout does not honour is a complaint, not a sale. */
let DEPTH_TOL  = 1.0;
let STEP_CAP   = 3.0;
let CHAISE_TOL = 4.0;
let SECOND_OFF = 0.10;
let UPSELL_ON  = true;

/* ---------- what the result card has to answer ----------
   The card used to list the size and little else, which is fine for the
   question the customer arrived with and useless for the one they arrive at:
   is this wooden thing worth fifty dollars. Everything that answers that lived
   on the product page, so the only way to find it was to leave.

   These are the questions people actually ask before paying, in the order they
   ask them: what is it made of, will it take my weight, how hard is it to fit,
   what happens if it breaks, when does it come, and what if I am wrong.

   EVERY ONE OF THESE IS A CLAIM, so none of them is written here as final.
   The theme editor overwrites them through #bh-rules, and the values below are
   only what shows if the settings are ever missing. Do not put a figure here
   that is not substantiated elsewhere on the site. */
let SPECS = {
  material: '0.5\" solid wood panels under a bound fabric cover, not foam',
  load:     '400 lb across the product, over 280 lb on a single board',
  install:  'Under the cushions, no tools, about a minute',
  warranty: 'Lifetime on the board. Send a photo, keep the old one.',
  delivery: 'Free, arrives in about 5 business days',
  returns:  '30 days to send it back'
};

let sel = {type:null, w:null, d:null, c:null};

/* ---------- sectional sets ----------
   The chaise board covers a range of section lengths, not one length. Data that
   still carries the old single "chaise" number is read as a range of zero
   width, so a half-migrated catalog cannot produce a wrong answer. */
const chaiseLo = p => p.chaiseMin != null ? p.chaiseMin : p.chaise;
const chaiseHi = p => p.chaiseMax != null ? p.chaiseMax : p.chaise;
const isSet    = p => chaiseLo(p) != null && chaiseHi(p) != null;

function chaiseFits(p, c){
  if(c == null || !isSet(p)) return true;
  return c >= chaiseLo(p) - CHAISE_TOL && c <= chaiseHi(p) + CHAISE_TOL;
}

function pickBoard(pool, w, d){
  if(!pool.length) return null;
  const depths = [...new Set(pool.map(p=>p.depth))].sort((a,b)=>a-b);
  let fitting = depths.filter(x=>x <= d);
  if(!fitting.length) fitting = depths.filter(x=>x <= d + DEPTH_TOL);
  if(!fitting.length) return null;
  for(let i=fitting.length-1;i>=0;i--){
    const hit = pool.find(p=>p.depth===fitting[i] && w>=p.min && w<=p.max);
    if(hit) return {product:hit, stepped:false};
  }
  for(let i=fitting.length-1;i>=0;i--){
    const up = pool.filter(p=>p.depth===fitting[i] && p.min>w && (p.min-w)<=STEP_CAP)
                   .sort((a,b)=>a.min-b.min)[0];
    if(up) return {product:up, stepped:true};
  }
  return null;
}

function matchSectionalPair(mainW, chaiseW, d){
  const straight = CATALOG.filter(p=>p.type!=='sectional');
  const a = pickBoard(straight, mainW, d);
  const b = pickBoard(straight, chaiseW, d);
  if(!a || !b) return {status:'pair-fail', main:a, chaise:b};
  return {status:'pair', main:a.product, chaise:b.product,
          mainStepped:a.stepped, chaiseStepped:b.stepped,
          total:+(a.product.price + b.product.price).toFixed(2)};
}

/* ---------- closest options ----------
   Nobody gets a dead end. When the measurements do not land inside a band we
   still show the boards that come closest, with each one's exact width range
   and depth on the card, so the customer decides on numbers rather than being
   told to go away and measure again. A board deeper than the deck overhangs the
   front edge, so those are penalised hard and sink to the bottom. */
function fitScore(p, w, d){
  const wGap = w < p.min ? (p.min - w) : (w > p.max ? (w - p.max) : 0);
  const dGap = p.depth <= d ? (d - p.depth) * 0.6 : (p.depth - d) * 5;
  return wGap * 2 + dGap;
}
function nearest(type, w, d, limit){
  const wantSet = type === 'sectional';
  let pool = CATALOG.filter(p => wantSet ? true : p.type !== 'sectional');
  if(!pool.length) pool = CATALOG.slice();
  return pool.map(p => ({p, s: fitScore(p, w, d)}))
    .sort((a,b) => a.s - b.s || a.p.price - b.p.price)
    .slice(0, limit || 4).map(x => x.p);
}
function options(type, w, d){
  return {status:'options', list: nearest(type, w, d, 4)};
}

function match(type, w, d, c){
  if(type==='sectional'){
    const sets = CATALOG.filter(p=>p.type==='sectional');
    const setHit = pickBoard(sets, w, d);
    const setResult = setHit ? {
      status:'ok', product:setHit.product, depth:setHit.product.depth,
      stepped:setHit.stepped, chaiseGiven:c
    } : null;
    if(setResult && chaiseFits(setHit.product, c)) return setResult;
    if(c==null) return {status:'need-chaise'};
    const pair = matchSectionalPair(w, c, d);
    if(pair.status==='pair') return pair;
    if(setResult) return Object.assign(setResult, {chaiseOff:true});
    return options('sectional', w, d);
  }

  /* The tile the customer pressed, plus anything that tile is allowed to
     borrow. Picking Sofa at 74 inches now lands on the 68 to 81 board without
     being told he chose the wrong category. */
  let pool = poolFor(type);
  let redirected = null;

  // The customer picked a category by eye. The tape measure decides.
  const fitsHere = pool.some(p=>w>=p.min && w<=p.max);
  if(!fitsHere){
    const other = CATALOG.find(p=>p.type!=='sectional' && w>=p.min && w<=p.max);
    if(other){
      redirected = {from:type, to:other.type};
      pool = poolFor(other.type);
      type = other.type;
    }
  }

  const depths = [...new Set(pool.map(p=>p.depth))].sort((a,b)=>a-b);
  let fitting = depths.filter(x=>x <= d);
  if(!fitting.length) fitting = depths.filter(x=>x <= d + DEPTH_TOL);
  if(!fitting.length) return options(type, w, d);
  const depth = Math.max(...fitting);

  let cand = pool.filter(p=>p.depth===depth && w>=p.min && w<=p.max);
  let stepped = false;
  if(!cand.length){
    const larger = pool.filter(p=>p.depth===depth && p.min>w && (p.min-w)<=STEP_CAP)
                       .sort((a,b)=>a.min-b.min);
    if(larger.length){ cand=[larger[0]]; stepped=true; }
  }
  if(!cand.length){
    for(let i=fitting.length-2;i>=0;i--){
      const alt = pool.filter(p=>p.depth===fitting[i] && w>=p.min && w<=p.max);
      if(alt.length){ cand=alt; break; }
    }
  }
  if(!cand.length) return options(type, w, d);

  const p = cand[0];
  return {status:'ok', product:p, depth:p.depth, stepped, redirected};
}

/* ---------- rendering ---------- */
const money = n => '$' + n.toFixed(2);
const bandOf = p => p.min + '\"–' + p.max + '\"';
const chaiseBandOf = p => !isSet(p) ? ''
  : (chaiseLo(p) === chaiseHi(p) ? chaiseLo(p) + '\"' : chaiseLo(p) + '\"–' + chaiseHi(p) + '\"');
const nameOf = p => LABEL[p.type] + ' board, ' + bandOf(p) + ' wide, ' + p.depth + '\" deep';

/* A row disappears rather than printing an empty one, so emptying a setting in
   the editor removes the claim from the page instead of leaving a blank label
   where a promise used to be. */
const specRow = (label, value) => value
  ? `<div class=\"spec\"><dt>${label}</dt><dd>${value}</dd></div>` : '';

/* ---------- the second board ----------
   Most households that have one sagging seat have another one going the same
   way, bought at the same time and sat on by the same people. The moment we
   have just answered the first question is the cheapest order value we will
   ever add, because the shipping and the decision are already made.

   WHY THIS DOES NOT RECOMMEND ANYTHING. It used to print two suggested sizes.
   Two guesses at somebody's second sofa is worse than no guess: being shown
   something irrelevant at the moment of buying reads as a shop that has not
   understood you, and the offer gets ignored along with the guess. So the
   button states the saving plainly and then lets the customer say which seat
   they mean. Nobody knows their own living room better than they do.

   THE PRICE HERE IS A PROMISE THE CHECKOUT HAS TO KEEP. The automatic discount
   in Shopify takes SECOND_OFF off the cheaper of the two, once per order, so
   that is exactly what is calculated below. If you change one, change both. */
function bundle(a, b){
  const off = Math.min(a.price, b.price) * SECOND_OFF;
  return {total:+(a.price + b.price - off).toFixed(2), saved:+off.toFixed(2)};
}

function upsellBlock(p){
  if(!UPSELL_ON || SECOND_OFF <= 0) return '';
  // A sectional set is already two boards. A third is noise.
  if(!p || p.type === 'sectional') return '';
  const pct = Math.round(SECOND_OFF * 100);
  return `
    <div class=\"upsell\">
      <button type=\"button\" class=\"btn btn-secondary btn-block upopen\" aria-expanded=\"false\" aria-controls=\"uppick\">
        Add a second board and save ${pct}%
      </button>
      <p class=\"upnote\">Most homes have a second seat going the same way. Pick any other size and ${pct}% comes off the cheaper of the two, taken off for you at checkout.</p>
      <div class=\"uppick\" id=\"uppick\" hidden>
        <p class=\"upstep\">What is the second seat?</p>
        <div class=\"upchips\" id=\"uptypes\"></div>
        <div id=\"upsizewrap\" hidden>
          <p class=\"upstep\">Which size is it?</p>
          <div class=\"upchips\" id=\"upsizes\"></div>
        </div>
        <div id=\"upout\"></div>
      </div>
    </div>`;
}

/* The block above is printed as part of a big innerHTML, so the listeners have
   to be attached afterwards. Called at the end of render(). */
function wireUpsell(first){
  const open = document.querySelector('.upopen');
  if(!open || !first) return;
  const pick     = document.getElementById('uppick');
  const typesRow = document.getElementById('uptypes');
  const sizeWrap = document.getElementById('upsizewrap');
  const sizesRow = document.getElementById('upsizes');
  const out      = document.getElementById('upout');
  const pct      = Math.round(SECOND_OFF * 100);
  if(!pick || !typesRow || !sizeWrap || !sizesRow || !out) return;

  open.addEventListener('click', function(){
    const opening = pick.hidden;
    pick.hidden = !opening;
    open.setAttribute('aria-expanded', opening ? 'true' : 'false');
    if(opening) pick.scrollIntoView({block:'nearest', behavior:'smooth'});
  });

  ['recliner','loveseat','sofa-med','sofa-long','sectional'].forEach(function(t){
    if(!CATALOG.some(x => x.type === t)) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'upchip';
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = '<b>' + LABEL[t] + '</b>';
    b.addEventListener('click', function(){
      typesRow.querySelectorAll('.upchip').forEach(function(x){
        x.classList.remove('on'); x.setAttribute('aria-pressed','false');
      });
      b.classList.add('on'); b.setAttribute('aria-pressed','true');
      buildSizes(t);
    });
    typesRow.appendChild(b);
  });

  function buildSizes(t){
    sizesRow.innerHTML = '';
    out.innerHTML = '';
    poolFor(t)
      .filter(c => c.variantId !== first.variantId)
      .sort((a, b) => a.min - b.min || a.depth - b.depth)
      .forEach(function(c){
        const s = document.createElement('button');
        s.type = 'button';
        s.className = 'upchip';
        s.setAttribute('aria-pressed', 'false');
        s.innerHTML = '<b>' + bandOf(c) + ' × ' + c.depth + '\" deep</b><small>' + money(c.price) + '</small>';
        s.addEventListener('click', function(){
          sizesRow.querySelectorAll('.upchip').forEach(function(x){
            x.classList.remove('on'); x.setAttribute('aria-pressed','false');
          });
          s.classList.add('on'); s.setAttribute('aria-pressed','true');
          showPair(c);
        });
        sizesRow.appendChild(s);
      });
    sizeWrap.hidden = false;
    sizeWrap.scrollIntoView({block:'nearest', behavior:'smooth'});
  }

  /* Every number is spelled out. A bundle price a customer cannot take apart
     is a bundle price they do not trust, and this one has to survive being
     checked against the checkout total line by line. */
  function showPair(second){
    const b = bundle(first, second);
    out.innerHTML = `
      <div class=\"uptotal\">
        <div class=\"upline\"><span>${nameOf(first)}</span><span>${money(first.price)}</span></div>
        <div class=\"upline\"><span>${nameOf(second)}</span><span>${money(second.price)}</span></div>
        <div class=\"upline upsave\"><span>${pct}% off the cheaper board</span><span>&minus;${money(b.saved)}</span></div>
        <div class=\"upsum\"><span>Both boards</span><b>${money(b.total)}</b></div>
      </div>
      <a class=\"btn btn-primary btn-block btn-lg\" data-buy-label=\"Buy both now, ${money(b.total)}\" href=\"/cart/${first.variantId}:1,${second.variantId}:1\">Buy both now, ${money(b.total)}</a>
      <p class=\"upnote\">Measure the second seat before you order it, the same way: bare deck, cushions off.</p>`;
    out.scrollIntoView({block:'nearest', behavior:'smooth'});
  }
}

/* One product card, one place. Every result view uses it, so the customer
   always gets the same thing: a picture of what arrives, the exact width range
   and depth, the price, and a way to buy. Text alone leaves people guessing
   what turns up in the box, and that hesitation is where the sale goes. */
function optCard(p){
  const inBand   = sel.w >= p.min && sel.w <= p.max;
  const fitsDeep = p.depth <= sel.d;
  return `
    <div class=\"optcard${inBand && fitsDeep ? ' optbest' : ''}\">
      <div class=\"optimg\"><img src=\"${p.img || ''}\" alt=\"${nameOf(p)}\" loading=\"lazy\" width=\"96\" height=\"96\"></div>
      <div class=\"optmain\">
        <h4>${nameOf(p)}</h4>
        <div class=\"optdim\">
          <span${inBand ? ' class=\"hit\"' : ''}>Width ${bandOf(p)}</span>
          <span${fitsDeep ? ' class=\"hit\"' : ''}>Depth ${p.depth}\"</span>
          ${isSet(p) ? `<span>Chaise ${chaiseBandOf(p)}</span>` : ''}
        </div>
      </div>
      <div class=\"optbuy\">
        <div class=\"pprice\">${money(p.price)}</div>
        <a class=\"btn btn-primary\" href=\"/cart/${p.variantId}:1\">Add to cart</a>
        <a class=\"rlink\" href=\"/products/${p.handle}?variant=${p.variantId}\"><u>Details</u></a>
      </div>
    </div>`;
}

/* "Show me everything" escape hatch. Some people would rather scan the whole
   range than be handed one answer, and refusing them that costs a sale. */
function showAll(){
  const out = document.getElementById('out');
  const head = document.getElementById('rhead');
  head.textContent = 'Every size we make';
  const order = ['recliner','loveseat','sofa-med','sofa-long','sectional'];
  const groups = order.map(t => [t, CATALOG.filter(p=>p.type===t)]).filter(g=>g[1].length);
  out.innerHTML = `
    <div class=\"result\">
      <div class=\"rmatch\">${CATALOG.length} sizes in stock</div>
      <h3>The full range</h3>
      <p style=\"margin-bottom:20px;font-size:1rem\">Measure the bare deck with the cushions out, then match the width and depth below. Whatever you order has to sit inside your seat area, not on top of it.</p>
      ${groups.map(([t,list]) => `
        <h4 class=\"optgroup\">${LABEL[t]}</h4>
        <div class=\"optlist\">${list.slice().sort((a,b)=>a.min-b.min||a.depth-b.depth).map(optCard).join('')}</div>
      `).join('')}
      <div class=\"rlinks\">
        <a class=\"rlink\" href=\"/pages/measuring-guide\"><u>How to measure the deck</u></a>
        <a class=\"rlink\" href=\"/pages/contact\"><u>Send us your measurements and we will confirm</u></a>
      </div>
    </div>`;
  out.scrollIntoView({block:'start', behavior:'smooth'});
}
window.bhShowAll = showAll;

function helpCard(title, paras){
  return `<div class=\"helpbox\"><h4>${title}</h4>${paras.map(t=>`<p>${t}</p>`).join('')}
    <a class=\"btn btn-primary btn-block\" href=\"/pages/contact\">Send us your measurements</a></div>`;
}

function render(r){
  const out  = document.getElementById('out');
  const head = document.getElementById('rhead');
  head.textContent = 'Here’s your match';

  if(r.status==='need-chaise'){
    head.textContent = 'One more number';
    out.innerHTML = helpCard('We need the chaise length too',
      ['Sectionals need all three measurements before we can size them properly. Go back a step and add the length of the shorter arm.']);
    return;
  }

  if(r.status==='pair'){
    head.textContent = 'Your sectional needs two boards';
    const m=r.main, ch=r.chaise;
    out.innerHTML = `
      <div class=\"result\">
        <div class=\"rmatch\">Custom pair for your layout</div>
        <h3>Two boards, sized to each section</h3>
        <p style=\"margin-bottom:20px;font-size:1rem\">Your measurements don't line up with one of our ready-made sectional sets, so rather than force a set that doesn't fit, here's a pair sized to your actual sections.</p>
        <div class=\"optlist\">${optCard(m)}${optCard(ch)}</div>
        <div class=\"pairtotal\"><span>Both boards together</span><b>${money(r.total)}</b></div>
        ${(r.mainStepped||r.chaiseStepped) ? `<div class=\"warnbox\">
          <b>Worth knowing:</b> ${r.mainStepped?'the main-run board':''}${(r.mainStepped&&r.chaiseStepped)?' and ':''}${r.chaiseStepped?'the chaise board':''} sits just above your measurement. Close the panel gaps to bring it in.
        </div>` : ''}
        <a class=\"btn btn-primary btn-block btn-lg\" data-buy-label=\"Buy both now, ${money(r.total)}\" href=\"/cart/${m.variantId}:1,${ch.variantId}:1\">Buy both now, ${money(r.total)}</a>
        <div class=\"buytrust\">
          <span>Free shipping on both</span><span>30-day returns (postage at your cost)</span><span>Secure checkout</span>
        </div>
        <p class=\"confirmnote\">Nothing's in your cart yet. Check both widths against your sections first.</p>
        <div class=\"rlinks\">
          <a class=\"rlink\" href=\"#\" onclick=\"bhShowAll();return false\"><u>Show me every size instead</u></a>
          <a class=\"rlink\" href=\"/pages/contact\"><u>Have someone check this layout for me</u></a>
        </div>
      </div>`;
    return;
  }

  if(r.status==='options'){
    head.textContent = 'Boards that fit your measurements';
    out.innerHTML = `
      <div class=\"result\">
        <div class=\"rmatch\">Closest to ${sel.w}\" wide &times; ${sel.d}\" deep</div>
        <h3>Here is what we have near your size</h3>
        <p style=\"margin-bottom:20px;font-size:1rem\">Listed nearest first. Check the width range and depth on each one against your own numbers, and pick the one that sits inside your seat area.</p>
        <div class=\"optlist\">${r.list.map(optCard).join('')}</div>
        <div class=\"buytrust\">
          <span>Free shipping</span><span>30-day returns (postage at your cost)</span><span>Secure checkout</span>
        </div>
        <div class=\"rlinks\">
          <a class=\"rlink\" href=\"#\" onclick=\"bhShowAll();return false\"><u>Show me every size instead</u></a>
          <a class=\"rlink\" href=\"/pages/measuring-guide\"><u>How to measure the deck</u></a>
          <a class=\"rlink\" href=\"/pages/contact\"><u>Send us your measurements and we will confirm</u></a>
        </div>
      </div>`;
    return;
  }

  const p = r.product;

  /* WHAT IS AND IS NOT ON THIS LIST.

     Gone: "You measured" and "Furniture". The first was a lie by arithmetic.
     Somebody who answered with the buttons never measured anything, and the
     figure shown was the midpoint of the band they pressed, so the card quoted
     a number back to them that they had never said. The second repeated the
     word already sitting in the heading directly above it.

     Added: the questions somebody actually asks between seeing a price and
     paying it. They used to be answerable only by leaving for the product
     page, and a customer who leaves to check whether a board is solid wood is
     a customer who may not come back. */
  out.innerHTML = `
    <div class=\"result\">
      <div class=\"rmatch\">Your size</div>
      <div class=\"resulthead\">
        <div class=\"resultimg\"><img src=\"${p.img || ''}\" alt=\"${nameOf(p)}\" width=\"150\" height=\"150\"></div>
        <h3>${nameOf(p)}</h3>
      </div>

      <dl class=\"specs\">
        <div class=\"spec\"><dt>Fits inner width</dt><dd>${bandOf(p)}</dd></div>
        <div class=\"spec\"><dt>Board depth</dt><dd>${p.depth}\"</dd></div>
        ${isSet(p) ? `<div class=\"spec\"><dt>In the box</dt><dd>2 pieces, main run plus a chaise board for ${chaiseBandOf(p)}</dd></div>` : ''}
        ${specRow('What it is', SPECS.material)}
        ${specRow('Holds', SPECS.load)}
        ${specRow('Fitting it', SPECS.install)}
        ${specRow('Warranty', SPECS.warranty)}
        ${specRow('Delivery', SPECS.delivery)}
        ${specRow('If it is not right', SPECS.returns)}
      </dl>

      ${r.redirected ? `<div class=\"warnbox\">
        <b>One adjustment:</b> you picked <b>${LABEL[r.redirected.from]}</b>, but a ${sel.w}\" deck falls in our <b>${LABEL[r.redirected.to]}</b> range. We've matched you to the right board, because the tape measure wins over the label.
      </div>` : ''}

      ${r.chaiseOff ? `<div class=\"warnbox\">
        <b>Read this before you order.</b> This set fits your ${sel.w}\" main run, but its chaise board covers ${chaiseBandOf(p)} and you measured ${sel.c}\". The main run will be right; the chaise section won't be fully covered. Message us first, because we'd rather sort this out than have you send it back.
      </div>` : ''}

      ${r.stepped ? `<div class=\"warnbox\">
        <b>Worth knowing:</b> your ${sel.w}\" width sits just under this size's range. It's still the right call, so close the gaps between the panels to bring it in to your exact width.
      </div>` : ''}

      ${p.depth < sel.d ? `<p class=\"muted\" style=\"margin-bottom:18px;line-height:1.55\">
        This board is ${p.depth}\" deep against a ${sel.d}\" seat. That's on purpose, because it tucks fully inside the seat area without reaching the front edge.
      </p>` : ''}

      <div class=\"pricerow\"><span class=\"price\">${money(p.price)}</span></div>
      <p class=\"ship\">Free shipping, contiguous US</p>

      <a class=\"btn btn-primary btn-block btn-lg\" data-buy-label=\"Buy now, ${money(p.price)}\" href=\"/cart/${p.variantId}:1\">Buy now, ${money(p.price)}</a>

      ${upsellBlock(p)}

      <div class=\"buytrust\">
        <span>Free shipping</span><span>30-day returns (postage at your cost)</span><span>Secure checkout</span>
      </div>
      <p class=\"confirmnote\">Nothing's in your cart yet. Check the width and depth above against your sofa first.</p>

      <div class=\"rlinks\">
        <a class=\"rlink\" href=\"/products/${p.handle}?variant=${p.variantId}\"><u>See the full product page</u></a>
        <a class=\"rlink\" href=\"#\" onclick=\"bhShowAll();return false\"><u>Show me every size instead</u></a>
        <a class=\"rlink\" href=\"/pages/measuring-guide\"><u>Check my measurements again</u></a>
        <a class=\"rlink\" href=\"/pages/contact\"><u>Just check it for me</u></a>
      </div>
    </div>`;

  wireUpsell(p);
}

/* ---------- SHOPIFY BRIDGE ----------
   On the live theme the catalog and the rules are rendered into the page from
   real variant data and theme settings. When present they replace the constants
   above, so nobody edits JavaScript to change a price, a size or a tolerance.
   The array above stays as a working fallback. */
(function(){
  function readJSON(id){
    const el = document.getElementById(id);
    if(!el) return null;
    try { return JSON.parse(el.textContent); } catch(e){
      console.warn("[BEN'SHOME] could not parse #" + id, e); return null;
    }
  }

  const rules = readJSON('bh-rules');
  if(rules){
    if(typeof rules.depthTolerance  === 'number') DEPTH_TOL  = rules.depthTolerance;
    if(typeof rules.stepCap         === 'number') STEP_CAP   = rules.stepCap;
    if(typeof rules.chaiseTolerance === 'number') CHAISE_TOL = rules.chaiseTolerance;
    if(typeof rules.secondItemDiscount === 'number') SECOND_OFF = rules.secondItemDiscount / 100;
    if(typeof rules.upsellEnabled      === 'boolean') UPSELL_ON  = rules.upsellEnabled;
    // Every claim on the result card comes from the editor, never from here.
    if(rules.specs && typeof rules.specs === 'object') Object.assign(SPECS, rules.specs);
    window.BH_RULES = rules;
  }

  const live = readJSON('bh-catalog');
  if(Array.isArray(live)){
    // Only fully specified, in-stock rows are trusted. A half-configured variant
    // must never become a recommendation, and a sold-out one must never be shown.
    const clean = live.filter(p =>
      p && LABEL[p.type] && p.depth > 0 && p.min > 0 && p.max >= p.min && p.price > 0 && p.stock
    );
    if(clean.length){
      CATALOG = clean;
    } else if(live.length){
      console.warn("[BEN'SHOME] size finder: " + live.length +
        " variants found but none were complete and in stock. Using fallback catalog.");
    }
  }
})();
